import { BaseService } from "./../../base";
export class RecipeService extends BaseService {
  static get entity() {
    return "recipe_aps";
  }
  static get name() {
    return "recipe_aps";
  }
  /**
   *
   * @param {Number} id Node_id
   * @returns
   */
  static async getByRut(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_rut/${id}`, this.name);
  }
}
